const NODE_MAP = {};

export default NODE_MAP;